import { Collection } from 'modules/core/lib/mobx-rest'
import createCollectionContext from 'modules/core/store/collections/CollectionContext'

import WorkArea from 'modules/locations/store/models/WorkArea'

class WorkAreas extends Collection<WorkArea> {
  get cacheKey(): string {
    return 'locationsWorkAreas'
  }

  get indexes() {
    return ['location_id']
  }

  model() {
    return WorkArea
  }
}

const singleton: WorkAreas = new WorkAreas()

export default singleton

const { provider: WorkAreasProvider, hook: useWorkAreas } = createCollectionContext<
  WorkArea,
  WorkAreas
>()
